import React from "react";
import "../styles/socialmedia.css";
import banner from "../assets/socialmediabanner.png";
import instatext from "../assets/instatext.png";
import twittertext from "../assets/twittertext.png";
import youtubetext from "../assets/youtubetext.png";
import followBtn from "../assets/followus.png";
import followBtninsta from "../assets/followusinsta.png";
import likefb from "../assets/likefb.png";
import fbext from "../assets/FACEBOOKtext.png";
import linkedtext from "../assets/linkedtext.png";
import subscribeBtn from "../assets/subscribe.png";
import visitweb from "../assets/visitbutton.png";
import warratytext from "../assets/warrantytext.png";
import warrantybtn from "../assets/warrantybtn.png";
import blogtext from "../assets/blogstext.png";
import blogbtn from "../assets/blogbtn.png";
import visitwebsite from "../assets/visitwebsite.png";

const SocialMedia = () => {
  return (
    <div className="social-page">
      {/* Banner */}
      <img src={banner} alt="" className="banner" />

      {/* Heading */}
      <div className="heading">
        <div className="line"></div>{" "}
        <h2>
          FOLLOW US ON <span>SOCIAL MEDIA</span>
        </h2>
        <div className="line"></div>
      </div>

      {/* Instagram */}
      <div className="social-card">
        <div className="content">
          <img src={instatext} alt="" className="social-banner" />
        </div>

        <a
          href="https://www.instagram.com/pixelpowertools/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={followBtninsta}
            alt="Follow us on Instagram"
            className="btn-img"
          />
        </a>
        {/* <img src={arrow} alt="" className="arrow" /> */}
      </div>
      <div className="social-card">
        <div className="content">
          <img src={linkedtext} alt="" className="social-banner" />
        </div>

        <a
          href="https://www.linkedin.com/company/pixeltoolsofficial/?viewAsMember=true"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={likefb} alt="Follow us on LinkedIn" className="btn-img" />
        </a>
      </div>

      {/* Facebook */}
      <div className="social-card">
        <div className="content">
          <img src={fbext} alt="Facebook" className="social-banner" />
        </div>
        <a
          href="https://www.facebook.com/pixelpowertools"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={likefb} alt="Like us on Facebook" className="btn-img" />
        </a>
      </div>

      {/* Twitter */}
      <div className="social-card">
        <div className="content">
          <img src={twittertext} alt="twitter" className="social-banner" />
        </div>

        <a
          href="https://x.com/Pixelpowertools"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={followBtn} alt="Follow us on X" className="btn-img" />
        </a>
        {/* <img src={arrow} alt="" className="arrow"  /> */}
      </div>

      {/* Youtube */}
      <div className="social-card">
        <div className="content">
          <img src={youtubetext} alt="twitter" className="social-banner" />
        </div>

        <a
          href="https://www.youtube.com/@pixelpowertools"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={subscribeBtn}
            alt="Subscribe on YouTube"
            className="btn-img"
          />
        </a>
      </div>
      <div className="social-card">
        <div className="content">
          <img src={blogtext} alt="" className="social-banner" />
        </div>

        <a
          href="https://pixeltools.in/Blogs"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={blogbtn} alt="Visit PixelTools Blogs" className="btn-img"/>
        </a>
        {/* <img src={arrow} alt="" className="arrow" /> */}
      </div>
      <div className="social-card">
        <div className="content">
          <img src={visitwebsite} alt="" className="social-banner" />
        </div>

        <a
          href="https://pixeltools.in/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={visitweb}
            alt="Visit PixelTools Website"
            className="btn-img"
          />
        </a>
      </div>
      <div className="social-card">
        <div className="content">
          <img src={warratytext} alt="" className="social-banner" />
        </div>
        <a
          href="https://pixeltools.in/warranty"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={warrantybtn} alt="" className="btn-img" />
        </a>
        {/* <img src={arrow} alt="" className="arrow" /> */}
      </div>
    </div>
  );
};

export default SocialMedia;
